import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

import apiEndpoints from '@dogfy/services/apiEndpoints'
import ApiService from '@dogfy/services/apiService'

export const useCampaignsStore = defineStore('campaigns', () => {
  // State
  // ----------------------
  const campaigns = ref([])
  const activeCampaign = ref({})

  // Getters
  // ----------------------
  const hasCampaignGift = computed(() => Object.keys(activeCampaign.value.gift || {}).length > 0)

  // Actions
  // ----------------------
  async function fetchActiveCampaigns () {
    try {
      const { data } = await ApiService.get(apiEndpoints.config.campaigns, { active: true })
      campaigns.value = data
    } catch (err) {
      console.error('  !! Could not fetch active campaigns.', err.message)
    }
  }

  function setActiveCountryCampaign (country) {
    const [activeCountryCampaign] = campaigns.value.filter(campaign => Object.keys(campaign.options[country] || {}).length > 0)

    if (activeCountryCampaign) {
      const isNewCampaign = activeCountryCampaign._id !== activeCampaign.value._id
      const isSameCampaignAndNewCountry = activeCountryCampaign._id === activeCampaign.value._id && country !== activeCampaign.value.country

      if (Object.keys(activeCampaign.value).length === 0 || isNewCampaign || isSameCampaignAndNewCountry) {
        activeCampaign.value = activeCountryCampaign.options[country].isApplicable
          ? { ...activeCountryCampaign.options[country], code: activeCountryCampaign.code }
          : { isApplicable: false }
        activeCampaign.value._id = activeCountryCampaign._id
        activeCampaign.value.country = country
        activeCampaign.value.baseTrialDiscountPercent = activeCampaign.value.baseTrialDiscount / 100
      }
    } else {
      activeCampaign.value = {}
    }
  }

  return {
    campaigns,
    activeCampaign,
    hasCampaignGift,
    fetchActiveCampaigns,
    setActiveCountryCampaign,
  }
})
